module.exports = __webpack_public_path__ + "img/26f.14507411.png";